import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/DeviceActions";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import InputBase from "../nativeBase-ui/InputBase";
import { faEdit } from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import UrlPicker from "../components/UrlPicker";

class AccessControlForm extends Component {
  constructor(props) {
    super(props);
    let { deviceId, deviceUId, areaId, areaUId } =
      this.props.navigation.state.params;
    this.state = {
      deviceId,
      deviceUId: deviceUId || null,
      deviceName: "",
      isLoading: true,
      accessToken: "",
      validation_deviceName_hasError: false,
      showingValidationErrors: false,
      validationErrors: [],
      showOnHomeScreen: true,
      areaId: areaId || null,
      areaUId: areaUId || null,
      ip: "",
      port: 0,
      brand: "",
      model: "",
      brands: [],
      models: [],
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.accessControl"),
  });
  componentDidMount() {
    // get data from reducer using state.deviceId
    var selectedBrand = "";
    if (this.state.deviceId || this.state.deviceUId) {
      var model = {};
      for (var i in this.props.reducer.list) {
        // get model from reducer
        if (
          this.props.reducer.list[i].deviceId == this.state.deviceId ||
          (this.state.deviceUId &&
            this.props.reducer.list[i].deviceUId == this.state.deviceUId)
        ) {
          model = this.props.reducer.list[i];
          selectedBrand = model.brand;
          this.setState({
            deviceName: model.deviceName,
            showOnHomeScreen: model.showOnHomeScreen,
            model: model.model,
            brand: model.brand,
            ip: model.ip,
            port: model.port,
          });
          break;
        }
      }
    }
    this.getBrands()
      .then((brands) => {
        if (selectedBrand) {
          this.getBrandModels(selectedBrand)
            .then((models) => {
              this.setState({ brands, models });
            })
            .catch((e) => {
              console.log(e);
              this.setState({ brands });
            });
        } else {
          if (!this.state.deviceId && brands.length > 0) {
            selectedBrand = brands[0];
            var port = selectedBrand == "Suprema" ? 51211 : 80;
            this.getBrandModels(selectedBrand)
              .then((models) => {
                this.setState({ brands, models, brand: selectedBrand, port });
              })
              .catch((e) => {
                console.log(e);
                this.setState({ brands, brand: selectedBrand, port });
              });
          } else {
            this.this.setState({ brands });
          }
        }
      })
      .catch(console.log);
    this.setState({
      accessToken: this.props.appReducer?.currentServer.accessToken,
      isLoading: false,
    });
  }

  getBrands = () => {
    return new Promise((resolve, reject) => {
      let serverUrl = this.props.appReducer.serverUrl;
      let access_token = this.props.appReducer?.currentServer.accessToken;
      if (!serverUrl.endsWith("/")) serverUrl += "/";

      var url = `${serverUrl}Devices/AccessControlBrands`;

      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((r) => r.json())
        .then((r) => {
          resolve(r);
        })
        .catch(reject);
    });
  };

  getBrandModels = (brand) => {
    return new Promise((resolve, reject) => {
      let serverUrl = this.props.appReducer.serverUrl;
      let access_token = this.props.appReducer?.currentServer.accessToken;
      if (!serverUrl.endsWith("/")) serverUrl += "/";

      var url = `${serverUrl}Devices/AccessControlModels?brand=${brand}`;

      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((r) => r.json())
        .then((r) => {
          resolve(r);
        })
        .catch(reject);
    });
  };

  goBack = () => {
    // this.props.navigation.navigate("DeviceList", { areaId: this.state.areaId });

    if (this.props.navigation) {
      // go back to prev screen
      this.props.navigation.goBack();

      // callback
      this.props.navigation.state.params.onGoBack &&
        this.props.navigation.state.params.onGoBack(DeviceTypes.ACCESS_CONTROL);

      return false;
    }
  };

  goToDeviceLog = () => {
    this.props.navigation.navigate("DeviceLogs", {
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
    });
  };

  save = () => {
    var model = {
      areaId: this.state.areaId,
      areaUId: this.state.areaUId,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
      deviceName: this.state.deviceName,
      showOnHomeScreen: this.state.showOnHomeScreen,
      brand: this.state.brand,
      model: this.state.model,
      ip: this.state.ip,
      port: this.state.port,
    };

    // validation
    let errors = [];
    if (!model.deviceName) {
      errors.push(
        `${translate("device.deviceName")} ${translate("app.isRequired")}`
      );
      this.setState({ validation_deviceName_hasError: true });
    }

    if (errors.length > 0) {
      this.showValidationAlert(errors);
      return;
    }
    // end of validation

    // if valid
    if (model.deviceId || model.deviceUId) {
      this.props.update(model, this.state.accessToken);
    } else {
      this.props.add(model, this.state.accessToken);
    }
    this.goBack();
  };

  showValidationAlert = (errors = []) => {
    this.setState({
      showingValidationErrors: true,
      validationErrors: [...errors],
    });
  };

  dismissValidationAlert = () => {
    this.setState({
      showingValidationErrors: false,
      validationErrors: [],
    });
  };

  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      const screenTitle =
        this.state.deviceId || this.state.deviceUId
          ? this.state.deviceName || translate("app.noName")
          : translate("device.defineNewDevice");
      return (
        <KeyboardAvoidingView
          behavior="height"
          style={{ flex: 1 }}
          enabled={true}
          keyboardVerticalOffset={80}
        >
          <ScrollView style={style.container}>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ color: Theme.COLORS.MUTED, flex: 1 }}>
                {this.state.areaName} : {translate("device.devices")} :{" "}
              </Text>
            </View>
            <Text style={style.screenTitle}>{screenTitle}</Text>
            {/* device name */}
            <InputBase
              isInvalid={this.state.validation_deviceName_hasError}
              label={translate("device.deviceName")}
              onChangeText={(txt) =>
                this.setState({
                  deviceName: txt,
                  validation_deviceName_hasError: txt.length == 0,
                })
              }
              value={this.state.deviceName}
              icon={faEdit}
            />
            {/* ip and port */}
            <UrlPicker
              label={translate("device.ip")}
              protocol={"http"}
              domain={this.state.ip}
              port={this.state.port}
              onChange={(deviceAddress, uri) => {
                this.setState({
                  ip: uri.domain,
                  port: uri.port,
                });
              }}
            />
            {/* brand */}
            <Select
              label={translate("device.brand")}
              data={this.state.brands.map((v) => {
                return { value: v, label: v };
              })}
              value={this.state.brand || ""}
              onChangeText={(value, index, data) => {
                this.setState({ brand: value }, () => {
                  this.getBrandModels(value)
                    .then((models) => {
                      this.setState({ models });
                    })
                    .catch(console.log);
                });
              }}
            />
            {/* brand models */}
            <Select
              label={translate("device.brandModels")}
              data={this.state.models.map((v) => {
                return { value: v, label: v };
              })}
              value={this.state.model || ""}
              onChangeText={(value, index, data) => {
                this.setState({ model: value });
              }}
            />
            <View
              style={{
                marginTop: 20,
              }}
            >
              <Switch
                label={translate("device.showOnHomeScreen")}
                isOn={this.state.showOnHomeScreen}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({
                    showOnHomeScreen: !this.state.showOnHomeScreen,
                  });
                }}
                animationSpeed={0}
              />
            </View>

            <HStack space={2} style={{ marginVertical: 10 }}>
              <ArButton
                color="primary"
                onPress={() => this.save()}
                style={{ flex: 1 }}
              >
                {translate("app.save")}
              </ArButton>
              <ArButton
                color="muted"
                variant="outline"
                onPress={() => this.goBack()}
                style={{ flex: 1 }}
              >
                {translate("app.goBack")}
              </ArButton>
            </HStack>
            {this.state.deviceId > 0 && (
              <ArButton
                color="success"
                style={{ marginBottom: 10, width: "100%" }}
                onPress={() => this.goToDeviceLog()}
              >
                {translate("area.logs")}
              </ArButton>
            )}
          </ScrollView>
          {/** validation alert */}
          {this.state.showingValidationErrors && (
            <AlertDialogBase
              isOpen={true}
              cancelText={translate("app.close")}
              cancelVariant="outline"
              onClose={() => this.dismissValidationAlert()}
            >
              <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
            </AlertDialogBase>
          )}
        </KeyboardAvoidingView>
      );
    }
  }
}

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (device, accessToken) =>
      dispatch(Actions.addAccessControl(device, accessToken)),
    update: (device, accessToken) =>
      dispatch(Actions.updateAccessControl(device, accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessControlForm);
